import { z } from 'zod';
import { createStringParserFromZodSchema, createValidatorFromParser } from '../../../utils';

const searchFilterFieldsSchema = z
    .object({
        Status: z.record(z.string(), z.string()).optional(),
    })
    .catchall(z.string().or(z.record(z.string(), z.string())));

export const searchFilterSchema = z
    .object({
        $filter: z.object({
            Prefix: z.string(),
            ConcatenationString: z.enum(['and', 'or']),
            Default: z.string(),
            Fields: searchFilterFieldsSchema,
        }),
    })
    .catchall(z.string());

export type SearchFilter = z.infer<typeof searchFilterSchema>;

const stringParser = createStringParserFromZodSchema(searchFilterSchema);

export const validateSearchFilterV2 = createValidatorFromParser(stringParser);

